import { PropsWithChildren, Suspense, memo } from 'react';

import { Loader } from 'components/common/index';

const LazyLoad = memo<PropsWithChildren>(({ children }) => (
  <Suspense fallback={<Loader linear />}>{children}</Suspense>
));

LazyLoad.displayName = 'LazyLoad';

export default LazyLoad;
